// Modal.jsx (or Modal.js)
"use client";

import { useState, useEffect } from "react";
import Login from "../pages/auth/views/Login";
import Register from "../pages/auth/views/Register";
import styles from "../css/modal.module.css"; // Import CSS Module

const Modal = ({ isOpen, onClose, initialForm, onOpenFrontShop }) => {
  const [isLogin, setIsLogin] = useState(initialForm === "login");

  useEffect(() => {
    setIsLogin(initialForm === "login");
  }, [initialForm]);

  if (!isOpen) return null;

  // Close modal when clicking outside
  const handleBackgroundClick = (event) => {
    if (event.target.id === "modal-popup") {
      onClose();
    }
  };

  return (
    <div
      id="modal-popup"
      className={styles.modalPopup}
      onClick={handleBackgroundClick}
    >
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {/* Single Close Button class used for all modal variants */}
        {/* <button
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button> */}

        {isLogin ? (
          <Login
            switchToRegister={() => setIsLogin(false)}
            closePopup={onClose}
            onOpenFrontShop={onOpenFrontShop}
          />
        ) : (
          <Register
            switchToLogin={() => setIsLogin(true)}
            closePopup={onClose}
          />
        )}
      </div>
    </div>
  );
};

export default Modal;
